import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Customer = styled.div`
  padding-left: 1.5em;
  position: relative;
  cursor: pointer;
  margin-bottom: 1em;
  width: fit-content;
  &:hover {
    color: #d24444;
  }
`

export const DeleteIcon = styled(FontAwesomeIcon)`
  color: #d24444;
  position: absolute;
  left: 0.1em;
  top: 0;
  font-size: 1em;
  &:hover {
    font-size: 1.2em;
    left: 0;
  }
`
